import DataTable from "../../../../../components/DataTable";

const Ports = ({ results }) => {
  const columns = [
    {
      id: "port",
      accessorFn: (row) => row?.["#text"] || "",
      header: () => <span>Port</span>,
      width: "50%",
      cell: ({ row }) => <span>{row.original?.["#text"]}</span>,
    },
    {
      accessorKey: "host",
      header: () => <span>Host</span>,
      width: "50%",
      cell: ({ row }) => <span>{row.original.host}</span>,
    },
  ];
  return (
    <div>
      {results && results.length > 0 && (
        <DataTable columns={columns} data={results} />
      )}
      {results && results.length === 0 && (
        <div className=" h-[45vh] w-full flex justify-center flex-col items-center text-center">
          <p className=" font-semibold text-xl">There are no results</p>
        </div>
      )}
    </div>
  );
};

export default Ports;
